import React, {useState} from "react";
import ProfilePhone from "./ProfilePhone";
import LogoutPhone from "./LogoutPhone";
import PuzzlePhoneUser from "../Games/Puzzle/PuzzlePhoneUser";

export default function ContainUser(props) {
    const ContainInfo = props.ContainInfo;
    const [ID] = useState(props.ID);

    if (ContainInfo==="Profile"){
        return (
        <div>
            <ProfilePhone ID={ID}/>
        </div>
        );
    }else if (ContainInfo==="Logout"){
        return (
        <div >
            <LogoutPhone ID={ID}/>
        </div>
        );
    }else if (ContainInfo==="Puzzle"){
        return (
        <div>
           <PuzzlePhoneUser ID={ID}/>
        </div>
        );
    } 
}